/* Greenleaf — card photos fade in as they arrive (12 Oct 2026, site audit, Andrew's yes).
 *
 * The fade itself is CSS (custom.css, next to the Show more rules): a lazy card photo
 * (.card__img[loading=lazy]) is transparent until it carries .is-in, and then fades in over
 * 0.35 s. Opacity only, so nothing on the page moves.
 *
 * This file switches it on (html.js-imgfade) only after every photo that has ALREADY arrived is
 * marked .is-in, so nothing that is already on screen blinks out. From then on a single listener
 * marks each photo as it loads (or fails, so a broken photo is never left invisible), which
 * also covers the cards that "Show more" adds later. With reduced motion it does nothing.
 */
(function () {
  'use strict';
  if (window.__glImgFade) return;
  window.__glImgFade = true;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  function done(e) {
    var t = e.target;
    if (t && t.classList && t.classList.contains('card__img')) t.classList.add('is-in');
  }
  // Load and error do not bubble; listening in the capture phase catches every image.
  document.addEventListener('load', done, true);
  document.addEventListener('error', done, true);

  var ims = document.querySelectorAll('.card__img');
  for (var i = 0; i < ims.length; i++) {
    if (ims[i].complete) ims[i].classList.add('is-in');
  }
  document.documentElement.classList.add('js-imgfade');
})();
